import React, { useEffect, useState } from 'react'

const Checkdata = () => {
    const [Statee, setStatee] = useState([]);
    const getdataAll = async () => {
        const sendData = {
            EmploymentRefId: Number(1),
            UserId: Number(0),
            MonthId: Number(10),
            YearId: Number(2022),
            ToYearId: Number(2022),
            ToMonthId: Number(10)
        }
        console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES1MISAll', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    console.log(data)
                    setStatee(data)



                })


    };
   /* useEffect(() => {
        getdataAll()
    },[])*/
    const data = new Array(5000).fill().map((value, index) => ({
        id: index,
        name: `Temp Name ${index}`,
        email: `Temp Email ${index}`
    }));

    return (
        <>
            <div>
                {data.map((item) => (
                    <div key={item.id}>
                        <h3>{item.name}</h3>
                        <p>{item.email}</p>
                    </div>
                ))}
            </div>
        </>
    )
}
export default Checkdata